import api from "../api/api";

export interface Bank {
  id: number;
  name: string;
  country_code: string;
  country_code_iso3: string;
}

export interface BanksByCountryNameResponse {
  country_name: string;
  banks: Bank[];
  count: number;
  message?: string;
}

export interface OrganizationResponse {
  label: string,
  value: string,
  iso2: string,
  iso3: string
}

export interface Country {
  id: number;
  name: string;
  iso3: string | null;
  numeric_code: string | null;
}

export type CountriesResponse = Country[];

export interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

// Get organizations by sector (user-facing)
export async function getAllOrgBySector(
  access_token: string,
  countryIso2: string,
  sector: number,
  subSector: number,
  all: boolean = false
): Promise<OrganizationResponse[]> {
  try {
    const response = await api.get<any>(`/api/v1/organizations/`, {
      headers: { Authorization: `Bearer ${access_token}` },
      params: {
        country: countryIso2,
        sector_id: sector,
        sub_sector_id: subSector,
        all
      }
    });
    // Handle different response structures
    // DRF pagination: { count, next, previous, results: [...] }
    // Custom pagination: { data: [...], total: ... }
    // Direct array: [...]
    const data = response.data?.results || response.data?.data || response.data || [];
    return Array.isArray(data) ? data : [];
  } catch (error: any) {
    console.error("Error fetching organizations:", error.response?.data || error.message);
    throw error;
  }
}

// Get all countries (user-facing - use lookup service instead)
export async function getAllCountries(
  access_token: string,
  sectorId?: number,
  subSectorId?: number
): Promise<CountriesResponse> {
  try {
    const params: Record<string, string | number> = {};
    if (sectorId) params.sector_id = sectorId;
    if (subSectorId) params.sub_sector_id = subSectorId;
    const res = await api.get<CountriesResponse>("/api/v1/lookup/countries/", {
      headers: { Authorization: `Bearer ${access_token}` },
      params,
    });
    console.log("Countries fetched:", res.data);
    return res.data;
  } catch (error: any) {
    console.error("Get all countries error:", error.response?.data || error.message);
    throw error;
  }
}

export interface OrganizationDetail {
  id: number;
  name: string;
  country_name: string;
}

export interface Organization {
  id: number;
  name: string;
  country_code_iso2: string;
  country_code_iso3: string;
}

export async function getOrganizationsByCountry(
  countryId: number,
  accessToken: string
): Promise<Organization[]> {
  try {
    const response = await api.get<Organization[]>(
      `/api/v1/admin/organizations/by-iso3/${countryId}`,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )
    return response.data
  } catch (error: any) {
    console.error(`Error fetching organizations for country ${countryId}:`, error.response?.data || error.message)
    throw error
  }
}
